export default __webpack_public_path__ + "static/media/Coco.f01ad48a.jpg";